import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('pqPartCkuSttsStore', Object.keys(getters)),
	...mapState('pqPartCkuSttsStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('pqPartCkuSttsStore', Object.keys(actions)),
	...mapMutations('pqPartCkuSttsStore', Object.keys(mutations))
};
